import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BackgroundMaskComponent } from '@app/shared/components/background-mask/background-mask-component';



@NgModule({
  declarations: [
    BackgroundMaskComponent
  ],
  imports: [
    FormsModule,
    CommonModule
  ],
  exports: [
    BackgroundMaskComponent
    ]
})
export class BackgroundMaskModule { }
